import { FC, useContext, useEffect } from "react"
import { ZipProjectContext } from "./ZipProjectContext"
import { NetworkProvidersPanel, ImpactProvidersPanel } from "@app/projects/servicing-provider";
import { useLocation } from "react-router-dom";
import { TableType, ViewableFieldsContext } from "@app/viewable-fields";
import { ZipCodeDisplayModel } from "./interfaces";
import { ProviderNetworkType } from "@app/projects/enumerators";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { NetworkProvidersComparisonPanel } from "@app/projects/servicing-provider/NetworkProvidersComparisonPanel";

export const ZipProjectProviders: FC = () => {
  const { state } = useContext(ZipProjectContext);
  const viewableFields = useContext(ViewableFieldsContext);
  const location = useLocation();
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  const regionSetId = (state.zipDetails[0] as ZipCodeDisplayModel)?.regionSetId;
  const specialtyGroupCode = (state.zipDetails[0] as ZipCodeDisplayModel)?.specialtyGroupCode;

  useEffect(() => {
    if (featureFlags.has(Features.ZIP_PROSPECT_AND_MARKET)) {
      viewableFields.getAllViewableFields([TableType.NetworkProviders, TableType.ProspectProviders, TableType.MarketProviders]);
    }
    else {
      viewableFields.getAllViewableFields([TableType.NetworkProviders]);
    }
  }, []);

  if (!regionSetId && !specialtyGroupCode) {
    return null;
  }

  return (
    <>
      {!state.isCompareMode ? (
        <>
          <NetworkProvidersPanel
            accessSummary={null}
            exportEndpoint={`/projects/${state.project?.projectId}/adequacy/export/${state.runConfiguration?.projectRunConfigurationId}/${state.runConfiguration?.isLatestPublished}`}
            nextClosestProviders={false}
            projectURL={location.pathname + location.search}
            regionSetId={regionSetId}
            specialtyGroupCode={specialtyGroupCode}
          />
          {featureFlags.has(Features.ZIP_PROSPECT_AND_MARKET) && !!state.runConfiguration.prospectProviderSetId &&
            <ImpactProvidersPanel
              accessSummary={null}
              exportEndpoint={`/projects/${state.project?.projectId}/adequacy/export/${state.runConfiguration?.projectRunConfigurationId}/${state.runConfiguration?.isLatestPublished}`}
              providerNetworkType={ProviderNetworkType.Prospect}
              projectURL={location.pathname + location.search}
              regionSetId={regionSetId}
              specialtyGroupCode={specialtyGroupCode}
            />}
          {featureFlags.has(Features.ZIP_PROSPECT_AND_MARKET) && !!state.runConfiguration.marketProviderSetId &&
            <ImpactProvidersPanel
              accessSummary={null}
              exportEndpoint={`/projects/${state.project?.projectId}/adequacy/export/${state.runConfiguration?.projectRunConfigurationId}/${state.runConfiguration?.isLatestPublished}`}
              providerNetworkType={ProviderNetworkType.Market}
              projectURL={location.pathname + location.search}
              regionSetId={regionSetId}
              specialtyGroupCode={specialtyGroupCode}
            />
          }
        </>
      ) : (
        <NetworkProvidersComparisonPanel
          exportEndpoint={`/projects/${state.project?.projectId}/adequacy/export/${state.runConfiguration?.projectRunConfigurationId}/${state.runConfiguration?.isLatestPublished}`}
          projectURL={location.pathname + location.search}
          regionSetId={regionSetId}
          specialtyGroupCode={specialtyGroupCode}
          exportComparedRunConfigurationId={state.compareToRunConfiguration.projectRunConfigurationId}
        />
      )}
    </>
  )
}